import {
  headerFooterService,
  APP_CONFIG,
  setInnerHTML,
  useAsyncEffect,
  authenticatedUserState,
  isMobile
} from '@sd/shared';
import { memo, useRef } from 'react';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';

type Props = {
  /**
   * This is used to fix an issue where the header was on top of modals
   */
  zIndex: number;
};
export const Header = memo(({ zIndex }: Props) => {
  const divRef = useRef<HTMLDivElement>(null);
  const authenticatedUser = useRecoilValue(authenticatedUserState);
  useAsyncEffect(async () => {
    const html = isMobile()
      ? ''
      : await headerFooterService
          .getSellHeader(authenticatedUser && { user: authenticatedUser.username, fullName: authenticatedUser.name })
          // Ignore errors here because we may navigate away from the page before this is done
          .catch(() => '');
    divRef.current &&
      setInnerHTML(
        divRef.current,
        html,
        // The Account Issues script loads *very* slowly in the lowers which causes navigation issues
        // so we ignore it in these environments
        ['dev', 'int1'].includes(APP_CONFIG.build.environment) ? [/accountissues\.js/] : undefined
      );
  }, [divRef.current, authenticatedUser]);
  return <Container zIndex={zIndex} ref={divRef} />;
});

const Container = styled.div<{ zIndex: number }>`
  #uhf-header--container {
    /* This fixes an issue where the header was on top of modals */
    z-index: ${props => props.zIndex};

    /* This prevents the header from auto-showing when you scroll up after you have scrolled down the page. */
    &.uhf-scrolling--down {
      position: static !important;

      &::before {
        display: none !important;
      }
    }
  }

  .uhf-search__input,
  .uhf-search__trigger {
    display: none !important;
  }

  .uhf-header-placeholder {
    display: none !important;
  }
`;
